import script from "./CollapsibleRowActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleRowActions.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsibleRowActions.vue?vue&type=style&index=0&id=58b752fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b752fd"]])

export default __exports__